import type {
  BusinessCreateRequestOptionType,
  BusinessCreateResponseType,
  CreateRetailerMetadataType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
  generateSellarMetaData,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useBusinessCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (request: {
      data: BusinessCreateRequestOptionType;
      sellarMetadata?: CreateRetailerMetadataType;
    }) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `businesses`,
        data: request.data,
        sellarMetadata: request.sellarMetadata
          ? generateSellarMetaData(request.sellarMetadata)
          : undefined,
      }).then(
        (response) =>
          apiV2AssertResponse(response).data as BusinessCreateResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Businesses],
      });
    },
  });
};
